var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fw-tabs"},[_c('router-link',{staticClass:"fw-tab",class:{ 'is-on': _vm.current === 'broadcasts' },attrs:{"to":"/avisos-e-campanhas"}},[_vm._v("Campanhas")]),_vm._v(" "),_c('router-link',{staticClass:"fw-tab",class:{ 'is-on': _vm.current === 'windows' },attrs:{"to":"/avisos-e-campanhas/liberacoes"}},[_vm._v("Liberação de funcionalidade")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a7155ea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/restricted/featureWindow/featureWindowTabs.vue
// module id = 904
// module chunks = 0